import { render, staticRenderFns } from "./adCount.vue?vue&type=template&id=936cdc66&"
import script from "./adCount.vue?vue&type=script&lang=js&"
export * from "./adCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('936cdc66')) {
      api.createRecord('936cdc66', component.options)
    } else {
      api.reload('936cdc66', component.options)
    }
    module.hot.accept("./adCount.vue?vue&type=template&id=936cdc66&", function () {
      api.rerender('936cdc66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/adCount.vue"
export default component.exports